export default {
	global : {
		bookings : 'Reservaciones',
		operation : 'Operación',
		operationAssignment : 'Asignación',
		import: 'Importar',
		importReservations: 'Importar Reservaciones',
		importReservation: 'Importar Reservación',
		downloadFormat: 'Descargar Formato',
		validateInformation: 'Validar información',
		file: 'Archivo',
		dateFormat: 'Formato de fecha',
		timeFormat: 'Formato de hora',
		typesServices: 'Tipos de servicios',
		operationTracking : 'Operación en vivo',
		transportUnits : 'Unidades',
		users : 'Usuarios',
		drivers : 'Conductores',
		profile : 'Perfil',
		logout : 'Salir',
		all : 'Todos',
		selectAll : 'TODOS',
		clean : 'Limpiar',
		search : 'Buscar',
		firstName : 'Nombres',
		lastName : 'Apellidos',
		save : 'Guardar',
		yes: 'Si',
		filters: 'Filtros',
		registerDeleted: 'Borrado exitosamente',
		serverError: 'El servidor no responde',
		ajaxTable:{
			noRecordsFound:'No se encontraron resultados',
			selectAll:'Seleccionar todos',
			showingNRecords:'Mostrando {from} a {to} registros de {total}',
			massiveOperationsOn: 'Habilitar operaciones masivas',
			massiveOperationsOff: 'Deshabilitar operaciones masivas',
			assignConfirmation: 'Asignar confirmación',
			orderBy:"Ordenar por"
		},
		status: 'Estado',
		actions: 'Acciones',
		copy: 'Copiar',
		minutes: 'minutos',
		after: 'después',
		before: 'antes',
		ofFlight: 'del vuelo',
		delete: 'Eliminar',
		add: 'Agregar',
		phone : 'Teléfono',
		email : 'Correo',
		cancel : 'Cancelar',
		update: 'Actualizar',
		description: 'Descripción',
		change: 'Cambiar',
		upload: 'Subir',
		info: 'Información',
		image: 'Imagen',
		pos: 'PV',
		selectOption:'Seleccione una opción',
		errorsFound: 'Se encontraron los siguientes errores al procesar archivo:',
		GenerateReservations: 'Generar reservas',
		errorsFoundAlert: 'Se encontraron errores en el archivo, por favor verificar',
		successfullyRegistered: 'Reservas registradas con éxito',
		supplier: 'Proveedor',
		pointOfSale: 'Punto de venta',
		dashboard:'Panel',
		reports:"Reportes",
		seeLocation:"Ver ubicación"
	},
	warnings : {
		okToContinue : '¿Desea continuar con esta acción?',
		continue : 'Continuar',
		cancel : 'Cancelar',
		processing : 'Procesando',
	},
	bookings : {
		passengers: 'Pasajeros',
		notAccepted: 'No aceptada',
		clientName:'Nombre cliente',
		airports:'Aeropuertos',
		general:'General',
		destinations:'Destinos',
		salesReference:'ID canal de venta',
		supplierConfirmed: 'Servicio confirmado',
		referenceId:'Confirmación Proveedor',
		serviceType:'Tipo de servicio',
		serviceStatus:'Estado de servicio',
		pickupConfirmed:'Pickup confirmado',
		serviceDateFrom:'Servicios desde',
		serviceDateTo:'Servicios hasta',
		flightNotValidate:'Vuelo no validado',
		transportUnit:'Unidad',
		driver:'Conductor',
		trackingStatus:'Estado de proceso',
		serviceStatusOpts:{
			active:		'Activo',
			pending:	'Pendiente',
			noShow:		'No Show',
			noProvided:	'No atendido',
			canceled:	'Cancelado',
			done:		'Realizado',
			partialCancellation: 'Pre Cancelado',
		},
		trackingStatusOpts:{
			pending:'Pendiente',
			onWayToPickup:'Rumbo al origen',
			atPickup:'En Origen',
			onWayToDropoff:'Rumbo al destino',
			finished:'Finalizado',
			noShow:'No show',
		},
		reservationStatusOpts:{
			active:'Activado',
			canceled:'Cancelado',
		},
		confirmed:'Confirmado',
		noConfirmed:'No confirmado',
		cancelDateFrom:'Fecha cancelación desde',
		cancelDateTo:'Fecha cancelación hasta',
		tripType:'Tipo de viaje',
		client:'Cliente',
		pickupDate:'Fecha pickup',
		trip:'Viaje',
		actions:'Acciones',
		export:'Exportar',
		booking:'Reservacion',
		clientInfo:'Datos de cliente',
		adults:'Adultos',
		kids:'Niños',
		infants:'Infantes',
		service:'Servicio',
		status:'Estado',
		origin:'Origen',
		destination:'Destino',
		route:'Ruta',
		dateTimeAndNumberOf:'Fecha, hora y numero de ',
		arrivalFlight:'Vuelo llegada',
		departureFlight:'Vuelo salida',
		pickupDatetime:'Fecha y hora de pickup',
		confirmData:'Confirmar datos',
		before:'antes',
		after:'despues',
		supplierNotes:'Notas al proveedor',
		flight:'vuelo',
		minutes:'minutos',
		serviceUpdatedSuccessfully:'Servicio actualizado con éxito',
		noShowEvidences:'Evidencias de No Show',
		noShowEvidenceMessage:'Para cambiar el estado del servicio a <strong>NO SHOW</strong>, por favor sube las pruebas correspondientes, que evidencien que el chófer y/o staff se encuentra en el tiempo y lugar programado.',
		doneEvidenceMessage:'Para cambiar el estado del servicio a <strong>REALIZADO</strong>, por favor sube las pruebas correspondientes, que evidencien que el chófer y/o staff se encuentra en el tiempo y lugar programado.',
		accepted:'Aceptado',
		shuttleCentralService:'Venta de Shuttle Central',
		selfService:'Servicio propio',
		rejectService:'Rechazar servicio',
		notes:'Notas',
		salesChannel:'Canal de venta',
		salesChannelReference:'Referencia canal de venta',
		noShow:'No Show',
		noProvided:'No atendido',
		cancel:'Cancelar',
		done:'Realizado',
		partialCancellation: 'Pre Cancelado',
		confirm:'Confirmar',
		copyRes:'Copiar reserva',
		createdBy:'Creado por',
		reservationDate:'Fecha de reservación',
		canceledBy:'Cancelado por',
		cancelationDate:'Fecha de cancelación',
		validate:'Validar',
		addService:'Agregar servicio',
		cancelRes:'Cancelar reserva',
		acceptService:'Aceptar servicio',
		servicesFrom: 'Servicios desde',
		servicesTo: 'hasta',
		clickFlightInfo:'Clic para ver la información del vuelo',
		flightNoValidate:'El vuelo no ha sido validado',
		newRes:'Nueva reserva',
		paxes:'Pasajeros',
		pickup:'Origen',
		dropoff:'Destino',
		transportInfo:'Datos del servicio',
		makeBooking:'Crear Reserva',
		Accepted: 'Servicios Confirmados',
		AcceptedOptions: {
			all: 'Todos',
			pending: 'Pendientes por confirmar',
			confirmed: 'Confirmados'
		},
		AcceptedOptionsMassive: {
			rejected: 'Rechazar',
			confirmed: 'Aceptar'
		},
		asignMsgPartial: "$TOTAL servicios no se pudieron actualizar ya que estaban previamente aceptados. Si requiere atencion adicional favor de contactar al personal de operaciones",
		asignMsg: 'Actualización exitosa',
		emptyStateSelect: 'No hay estado seleccionado',
		acceptReject: "Aceptar/Rechazar servicio",
		confirmAcceptService: "¿Estas seguro que desea ACEPTAR el servicio?",
		confirmRejectService : "¿Estas seguro que desea RECHAZAR el servicio?",
		selectServiceMassive: "Ningún servicio seleccionado",
		confirmSupplierConfirmationMassive:"¿Estas seguro que desea %{action} los servicios seleccionados?",
		assignDriverUnit: 'Asignación de conductor y vehículo',
		assign: 'Asignar',
		unassignedServices:'Servicios NO ASIGNADOS',
		assignedServices:'Servicios ASIGNADOS',
		reviews: 'Reseñas',
		withoutCommentsOnReview: 'El cliente no dejó comentarios',
		price: 'Precio'
	},
	users : {
		newUser:'Nuevo usuario',
		newDriver:'Nuevo conductor',
		name:'Nombre',
		email:'Corre electrónico',
		access:'Acceso',
		status:'Estado',
		actions:'Acciones',
		editingUser:'Editando usuario',
		editingDriver:'Editando conductor',
		firstName:'Nombres',
		lastName:'Apellidos',
		phone:'Teléfono',
		userInfo:'Información de usuario',
		language:'Idioma',
		accessTypeOpts : {
			master : 'Maestro',
			admin : 'Administrador',
			operation : 'Operación',
			driver : 'Conductor',
		},
		license:'Licencia',
		profilePicture:'Foto de perfil',
		profile:'Perfil',
		msgRegistered: 'Usuario agregado con éxito',
		msgUpdate: 'Usuario actualizado con éxito',
		msgRemoved: 'Usuario eliminado con éxito',
		password: 'Contraseña',
		resetPassword: "Restablecer la contraseña",
		newPassword : 'Nueva contraseña',
		repeatPassword : 'Repetir contraseña',
		updatedPassword : 'Contraseña actualizada',
		passwordAreDifferent : 'Contraseña son diferentes'
	},
	profile : {
		firstName : 'Nombres',
		lastName : 'Apellidos',
		email : 'Correo electrónico',
		phone : 'Teléfono',
		language : 'Idioma',
		changePassword : 'Cambiar contraseña',
		newPassword : 'Nueva contraseña',
		repeatPassword : 'Repetir contraseña',
		updatePassword : 'Actualizar contraseña',
		updatedPassword : 'Contraseña actualizada',
		passwordAreDifferent : 'Las contraseñas son diferentes',
		updatedData : 'Datos actualizados',
		changeSass: 'Cambiar de plataforma',
	},
	transportUnits : {
		newUnit: 'Nueva unidad',
		name: 'Nombre',
		plateNumber: '# Placas',
		unitBrand: 'Marca',
		unitModel: 'Modelo',
		unitModelYear: 'Año',
		maxPassengers: 'Max pasajeros',
		editUnit: 'Editar unidad',
		info: 'Información',
		unitPhoto: 'Foto de unidad',
	},
	driver : {
		myServices:'Mis servicios',
		changeUnit:'Cambiar unidad',
		noPermission: "No se tiene permisos de ubicación, activa el permiso para esta pagina en tu dispositivo",
		howAndroid: "Ver como en ANDROID",
		acceptPermission: "Haz clic y acepta el permiso de ubicación",
		findLocation: "Haz clic para encontrar tu ubicación",
	},
	AssignConfirmation: {
		oktitle: 'Asignar',
		title: 'Asignar confirmación',
		rowsMessage: 'Ha seleccionado $TOTAL registros para actualizar.'
	},
	confirm: {
		Si: true,
		No: false
	},
	transportServiceChangeStatus: {
		note: 'Registra una nota*',
		btnUpdate: 'Actualizar servicio',
		btnUpdateProcess: 'Procesando',
		btnCancel: 'Cancelar',
		title: 'Evidencias de estado',
	},
	transportServiceStatus: {
		pending:	'Pendiente',
		active:		'Activo',
		noShow:		'No show',
		noProvided:	'No atendido',
		canceled:	'Cancelado',
		done:		'Realizado',
		success:	'Servicio actualizado con éxito',
		partialCancellation: 'Pre Cancelado',
		activeDoneNoShow:"Activo+Realizado+No Show",
	},
	filesRelated: {
		emptyImg: 'No se ha cargado imagenes',
		fileDelete: 'Archivo eliminado',
		notSelectImg: 'No has seleccionado una imagen',
		uploadedFile: 'Archivo cargado',
	},
	statusOptions: {
		active: 'Activo',
		pending: 'Pendiente'
	},
	statusActive: {
		active: 'Activo',
		inactive: 'Inactivo'
	},
	accessTypes: {
		/*master: 'Maestro',*/
		admin: 'Administrador',
		operation: 'Operación',
		driver: 'Conductor',
	},
	langOptions: {
		es: 'Español',
		en: 'Ingles',
	},
	alerts:{
		trackingStatusChanged:"El servicio: {serviceNumber} ha cambiado de status a: {trackingStatus} "
	},
	dashboard:{
		startDate:"Fecha de inicio",
		endDate:"Fecha de finalización",
		compareBy:"Comparar por:",
		day:"Dia",
		week:"Semana",
		month:"Mes",
		year:"Año",
		volumenAssigned:"Servicios asignados",
		volumenAccepted:"Servicios aceptados",
		volumenRejected:"Servicios rechazados",
		ridesPerStatus:"Mi Operación",
		hideShowDataLabels:"Mostrar/Ocultar etiquetas",
		driverPerformance:"Desempeño por operador",
		myRides:"Mis servicios",
		reviewPerDate: "Reviews por fecha"
	},
	reports:{
		myRevenue:"Mis ingresos",
		datesValidation:"Campos de fecha son requeridos.",
		currency:"Moneda",
		rate:"$ Tarifa",
		referenceData:"La información que se muestra esta sujeta a cambios a medida que tus estados de traslados y tu operación son actualizados.",
		rangeLimit:"Limite excedido ({days} días maximo por consulta)",
		reviews: "Reseñas"
	},
	rto:{
		drivers: "GPS Conductores",
		lastConnection:"Ultima actualización"
	}
}
